import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  /** Hides the full-screen preloader overlay. */
  hidden = false;

  ngOnInit(): void {
    // The theme hides this overlay via jQuery on window 'load' — but Angular renders it
    // AFTER that event fires, so it can stay forever (white screen until a refresh).
    // Hide it ourselves, framework-native, with a hard safety net so it can never trap the page.
    const hide = () => { this.hidden = true; };

    if (typeof document === 'undefined') { this.hidden = true; return; }

    if (document.readyState === 'complete') {
      setTimeout(hide, 350);
    } else {
      window.addEventListener('load', () => setTimeout(hide, 200), { once: true });
    }
    // Safety net: never let the preloader cover the page for more than ~2.5s.
    setTimeout(hide, 2500);
  }
}
